import * as React from "react";
const SvgEmptyIconPlaceholder = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props });
export default SvgEmptyIconPlaceholder;
